<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_pipe_size">{{ 'ขนาด (mm.)' }}</label>
                        <InputText
                            id="ifh_pipe_size"
                            type="text"
                            v-model="pipe_size"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_soi_name">{{ 'ซอย/ตรอก' }}</label>
                        <InputText
                            id="ifh_soi_name"
                            type="text"
                            v-model="soi_name"
                            ref="TextBox_2_search"
                            @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_road_name">{{ 'ถนน' }}</label>
                        <InputText
                            id="ifh_road_name"
                            type="text"
                            v-model="road_name"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_6_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="provinceOptions">{{ $t('province') }}</label>
                        <Dropdown
                            v-model="selectedProvince"
                            :options="provinceOptions"
                            optionLabel="province_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="provinceOptions">
                                <div v-if="provinceOptions.value">
                                    <div>{{ provinceOptions.value.province_name }}</div>
                                </div>
                            </template>
                            <template #option="provinceOptions">
                                <div>{{ provinceOptions.option.province_name }}</div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="amphurOptions">{{ $t('amphur') }}</label>
                        <Dropdown
                            :disabled="isDisabledAmphur == 1"
                            v-model="selectedAmphur"
                            :options="amphurOptions"
                            optionLabel="amphur_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="amphurOptions">
                                <div v-if="amphurOptions.value">
                                    <div>{{ amphurOptions.value.amphur_name }}</div>
                                </div>
                            </template>
                            <template #option="amphurOptions">
                                <div>{{ amphurOptions.option.amphur_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="tambonOptions">{{ $t('tambon') }}</label>
                        <Dropdown
                            :disabled="isDisabledTambon == 1"
                            v-model="selectedTambon"
                            :options="tambonOptions"
                            optionLabel="tambon_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="tambonOptions">
                                <div v-if="tambonOptions.value">
                                    <div>{{ tambonOptions.value.tambon_name }}</div>
                                </div>
                            </template>
                            <template #option="tambonOptions">
                                <div>{{ tambonOptions.option.tambon_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_community_name">{{ 'ชุมชน' }}</label>
                        <Dropdown
                            v-model="community_name"
                            :options="communityOptions"
                            optionLabel="community_name"
                            :dataKey="'community_id'"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    <div>{{ slotProps.value.community_name }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>

                            <template #option="slotProps">
                                <div class="EV_communityOptions">
                                    {{ slotProps.option.community_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </div>

                    <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" 
               v-if="!selectedProvince &&
                     !selectedAmphur &&
                     !selectedTambon">
            <label for="FireStationOptions">{{ $t("ira_FireStation") }} </label>
            <Dropdown
              
              v-model="FireStationSelected"
              :options="FireStationOptions"
              optionLabel="fs_tname"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="FireStationOptions">
                <div v-if="FireStationOptions.value">
                  <div>{{ FireStationOptions.value.fs_tname }}</div>
                </div>
              </template>
              <template #option="FireStationOptions">
                <div>{{ FireStationOptions.option.fs_tname }}</div>
              </template>
            </Dropdown>
          </div> -->
                    <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2" v-else> -->
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="FireStationOptions">{{ $t('ira_FireStation') }} </label>
                        <Dropdown
                            v-model="FireStationSelected"
                            :options="FireStationOptions_AT"
                            optionLabel="fs_tname"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="FireStationOptions_AT">
                                <div v-if="FireStationOptions_AT.value">
                                    <div>{{ FireStationOptions_AT.value.fs_tname }}</div>
                                </div>
                                <span v-else>
                                    {{ FireStationOptions_AT.placeholder }}
                                </span>
                            </template>
                            <template #option="FireStationOptions_AT">
                                <div>{{ FireStationOptions_AT.option.fs_tname }}</div>
                            </template>
                        </Dropdown>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="status">{{ 'สถานะ' }}</label>
                        <!-- <InputText
                id="ifs_status"
                type="text"
                v-model="status"
              /> -->
                        <Dropdown
                            v-model="status"
                            :options="status_Options_Search"
                            optionLabel=""
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="status_Options">
                                <div v-if="status_Options.value">
                                    <div>{{ status_Options.value }}</div>
                                </div>
                            </template>
                            <template #option="status_Options">
                                <div>{{ status_Options.option }}</div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifs_inspec_details">{{ 'รายละเอียดการตรวจสอบ' }}</label>
                        <InputText
                            id="ifs_inspec_details"
                            type="text"
                            v-model="inspec_details"
                            ref="TextBox_5_search"
                            @keyup.left="moveFocus($event, 'TextBox_4_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_firehydrant_code">{{ 'รหัสหัวจ่ายน้ำดับเพลิง' }}</label>
                        <InputText
                            id="ifh_firehydrant_code"
                            type="text"
                            v-model="ifh_firehydrant_code"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="ifh_inspec_result">{{ 'ผลการดำเนินงาน' }}</label>
                        <InputText
                            id="ifh_inspec_result"
                            type="text"
                            v-model="inspec_result"
                            ref="TextBox_9_search"
                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_6_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_6_search"
                                @keyup.left="moveFocus($event, 'TextBox_5_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7_search', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_6_search"
                                @keyup.left="moveFocus($event, 'TextBox_5_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7_search', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="fastSearchFireHydrant()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_7_search"
                                @keyup.left="moveFocus($event, 'TextBox_6_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8_search', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4_search', 'Input')"
                            />
                            <!-- <Button
                    @click="fastSearchFireHydrant()"
                    :label="$t('fastSearchBtn')"
                    class="p-button-danger p-ml-3"
                    ref="TextBox_8_search"
                    @keyup.left="moveFocus($event, 'TextBox_7_search','Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_search','Input')"
                    @keyup.up="moveFocus($event, 'TextBox_4_search','Input')"
                    style="width: 160px; display: inline-block;"
                  /> -->
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="FireHydrant_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>
        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? FireHydrant_Table : []"
                scrollHeight="500px"
                :lazy="true"
                :paginator="true"
                :rows="lazyParams.rows"
                :totalRecords="lazyParams.totalRecords"
                :first="lazyParams.first"
                @page="onPage"
                :sortOrder="1"
                sortField="index"
                dataKey="id"
                ref="dt"
                :exportFilename="`ข้อมูลหัวจ่ายน้ำดับเพลิง-${date}`"
                :rowHover="true"
                :selection.sync="selectedFireHydrant"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" จบ-->
                <template #header>
                    <div class="p-grid p-col">
                        <!-- <div class="table-header" id="Create" style="padding: 7px" v-if="checkAdd_data != 'false'">
                            <Button @click="FireHydrantModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div> -->

                        <div class="table-header" id="Create" style="padding: 7px" v-if="checkAdd_data != 'false'">
                            <Button @click="FireHydrantModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>
                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" id="EX" style="padding: 7px">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" id="PDF" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedFireHydrant && selectedFireHydrant.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.length === FireHydrant_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedFireHydrant.some((item) => item.firehydrant_id === slotProps.data.firehydrant_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.index }}</div>
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                    <!--Doe : เพิ่มลำดับ 2/4 จบ-->
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_img == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img == true">
                                <div
                                    v-if="
                                        dataTable.data.image !== '' &&
                                        dataTable.data.image !== null &&
                                        dataTable.data.image !== 'undefined' &&
                                        dataTable.data.image !== undefined &&
                                        columns_img == true
                                    "
                                >
                                    <img
                                        :src="pickRecordImage(dataTable.data, 'image', 'image_cloud')"
                                        @click="showImage(pickRecordImageRaw(dataTable.data, 'image', 'image_cloud'))"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_img_cloud == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img_cloud == true">
                                <div
                                    v-if="
                                        dataTable.data.image_cloud !== '' &&
                                        dataTable.data.image_cloud !== null &&
                                        dataTable.data.image_cloud !== 'undefined' &&
                                        dataTable.data.image_cloud !== undefined &&
                                        columns_img_cloud == true
                                    "
                                >
                                    <img
                                        :src="pickRecordImage(dataTable.data, 'image_cloud', 'image')"
                                        @click="showImage(pickRecordImageRaw(dataTable.data, 'image_cloud', 'image'))"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_genqr == true">
                    <Column field="" :header="'QR Code'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_genqr == true">
                                <div
                                    v-if="
                                        dataTable.data.code !== '-' &&
                                        dataTable.data.code !== '' &&
                                        dataTable.data.code !== null &&
                                        dataTable.data.code !== 'undefined' &&
                                        dataTable.data.code !== undefined &&
                                        columns_genqr == true
                                    "
                                >
                                    <Button
                                        @click="genQrCode(dataTable.data.code)"
                                        icon="pi pi-image"
                                        :label="table_genQR"
                                        class="p-button-rounded p-button-info"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_pipe_size == true">
                    <Column field="pipe_size" :header="'ขนาด (mm.)'" :headerStyle="tableColSticky('20rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_pipe_size == true">
                                {{ dataTable.data.pipe_size }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_code == true">
                    <Column field="code" :header="$t('ifh_code_name')" :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_code == true">
                                {{ dataTable.data.code }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <div v-if="columns_inspec_result == true">
                    <Column field="inspec_result" :header="'ผลการดำเนินการ'" :headerStyle="tableColSticky('17rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_inspec_result == true">
                                {{ dataTable.data.inspec_result }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <div v-if="columns_soi_name == true">
                    <Column field="soi_name" :header="'ซอย/ตรอก'" :headerStyle="tableColSticky('22rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_soi_name == true">
                                {{
                                    dataTable.data.soi_name == 'null' || dataTable.data.soi_name == '' || dataTable.data.soi_name == null
                                        ? '-'
                                        : dataTable.data.soi_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_road_name == true">
                    <Column field="road_name" :header="'ถนน'" :headerStyle="tableColSticky('22rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_road_name == true">
                                {{ dataTable.data.road_name == 'null' || dataTable.data.road_name == '' ? '-' : dataTable.data.road_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_community_name == true">
                    <Column field="community_name" :header="'ชุมชน'" :headerStyle="tableColSticky('22rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_community_name == true">
                                {{ dataTable.data.community_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status == true">
                    <Column field="status" :header="'สถานะ'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_status == true">
                                <div v-if="dataTable.data.status == 'ปกติ'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FE0000',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.status }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.status == 'ชำรุด'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#ff692e',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.status }}
                                    </div>
                                </div>
                                <div v-else class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#A09B9B',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.status }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_fire_station == true">
                    <Column field="fire_station" :header="'สถานีดับเพลิงและกู้ภัย'" :headerStyle="tableColSticky('22rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_fire_station == true">
                                {{ dataTable.data.fire_station }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_location == true">
                    <Column field="location" :header="'ที่ตั้ง'" :headerStyle="tableColSticky('22rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_location == true">
                                {{ dataTable.data.location }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_tambon_name == true">
                    <Column field="tambon_name" :header="'แขวง/ตำบล'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_tambon_name == true">
                                {{
                                    dataTable.data.tambon_name == 'null' || dataTable.data.tambon_name == null || dataTable.data.tambon_name == ''
                                        ? '-'
                                        : dataTable.data.tambon_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_amphur_name == true">
                    <Column field="amphur_name" :header="'เขต/อำเภอ'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_amphur_name == true">
                                {{
                                    dataTable.data.amphur_name == 'null' || dataTable.data.amphur_name == null || dataTable.data.amphur_name == ''
                                        ? '-'
                                        : dataTable.data.amphur_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_province_name == true">
                    <Column field="province_name" :header="'จังหวัด'" :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_province_name == true">
                                {{
                                    dataTable.data.province_name == 'null' ||
                                    dataTable.data.province_name == null ||
                                    dataTable.data.province_name == ''
                                        ? '-'
                                        : dataTable.data.province_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <div v-if="columns_status == true">  
            <Column
              field="status"
              :header="'สถานะ'"
              
              headerStyle="width: 15rem"
            >
              <template #body="dataTable">
                
                <div v-if="dataTable.data.status == 'ปกติ'">
                  <div :style="{color: '#fff', backgroundColor:'#2ECC71', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' , borderRadius:'10px'}">
                      {{ dataTable.data.status }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.status == 'ชำรุด'">
                  <div :style="{color: '#fff', backgroundColor:'#FE0000', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' , borderRadius:'10px'}">
                      {{ dataTable.data.status }}
                  </div>
              </div>
              <div v-else>
                  <div :style="{color: '#fff', backgroundColor:'#A09B9B', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' , borderRadius:'10px'}">
                      {{ dataTable.data.status }}
                  </div>
              </div>
              </template>
            </Column>
        </div>
        <div v-else>
              <Column :headerStyle="tableColNone()"></Column>
        </div> -->

                <div v-if="columns_inspec_details == true">
                    <Column field="inspec_details" :header="'รายละเอียดการตรวจสอบ'" :headerStyle="tableColSticky('17rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_inspec_details == true">
                                {{ dataTable.data.inspec_details }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lat == true">
                    <Column field="event_lat" :header="`ละติจูด`" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_event_lat == true">
                                {{ parseFloat(dataTable.data.event_lat).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_event_lon == true">
                    <Column field="event_lon" :header="`ลองจิจูด`" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_event_lon == true">
                                {{ parseFloat(dataTable.data.event_lon).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column field="date_create_ddmmyy" :header="'วันที่สร้างข้อมูล'" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column field="date_update_ddmmyy" :header="'วันที่ปรับปรุงข้อมูล'" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_create_by_fullname == true">
                    <Column field="create_by_fullname" :header="'ผู้สร้างข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_create_by_fullname == true">
                                {{ dataTable.data.create_by_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_edit_by_fullname == true">
                    <Column field="edit_by_fullname" :header="'ผู้แก้ไขข้อมูล'" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_edit_by_fullname == true">
                                {{ dataTable.data.edit_by_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_fire_hydrant_detail == true">
                    <Column field="firehydrant_id" :header="`รายละเอียด`" :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_fire_hydrant_detail === true">
                                <a
                                    :href="`/public/information/initial/fire-hydrant/details?firehydrantId=${dataTable.data.firehydrant_id}`"
                                    class="hover-effect"
                                >
                                    ดูรายละเอียด
                                </a>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_fire_hydrant_detail ||
                        columns_event_lon ||
                        columns_index ||
                        columns_pipe_size ||
                        columns_code ||
                        columns_genqr ||
                        columns_img ||
                        columns_soi_name ||
                        columns_road_name ||
                        columns_community_name ||
                        columns_fire_station ||
                        columns_location ||
                        columns_tambon_name ||
                        columns_amphur_name ||
                        columns_province_name ||
                        columns_status ||
                        columns_inspec_details ||
                        columns_inspec_result ||
                        columns_event_lat ||
                        columns_date_create ||
                        columns_date_update ||
                        columns_create_by_fullname ||
                        columns_edit_by_fullname
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="permissionEnabled(checkEdit_data) || permissionEnabled(checkDelete_data)"
                    >
                        <template #body="dataTable">
                            <div v-if="dataTable.data.status !== 'ระหว่างติดตั้ง' || manageInstallingFirehydrant">
                            <!-- <div class="p-formgrid" v-if="checkNotAdminPermission(dataTable.data.user_organize)"> -->
                            <div class="p-formgrid" v-if="checkDiv14()">
                                <div class="p-formgrid col_manege">
                                    <div :class="table_BOXmanege" v-if="permissionEnabled(checkEdit_data)">
                                        <!-- FireHydrantModal = true; -->
                                        <Button
                                            @click="
                                                editData(dataTable.data.firehydrant_id);
                                                temp = dataTable.data.firehydrant_id;
                                            "
                                            icon="pi pi-pencil"
                                            :label="table_editBTN"
                                            class="p-button-rounded p-button-warning"
                                        />
                                    </div>
                                    <div :class="table_BOXmanege" v-if="permissionEnabled(checkDelete_data)">
                                        <Button
                                            @click="
                                                // displayConfirmation = true;
                                                temp = dataTable.data.firehydrant_id;

                                                alertDisplay(temp);
                                            "
                                            icon="pi pi-trash"
                                            :label="table_deleteBTN"
                                            class="p-button-rounded p-button-danger"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="FireHydrantModal"
            :style="{ width: '80%' }"
            :header="header"
            id="dialog_ifh"
            :closable="loadingCreate ? false : true"
            :contentStyle="{ overflow: 'auto' }"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate" style="top: 38%">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ira_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <!-- <div class="p-formgrid p-grid"> -->
                    <div class="p-formgrid p-grid" style="display: flex; justify-content: space-between">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="ira_location_name">{{ 'ขนาด (mm.)' }} <span class="required-input">*</span></label>
                            <InputText
                                id="ifh_pipe_size"
                                @change="genCodeId"
                                type="text"
                                v-model="ifh_pipe_size"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_ifh_pipe_size && !ifh_pipe_size
                                }"
                                @input="acceptNumberPhone"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_ifh_pipe_size && !ifh_pipe_size">{{ 'กรุณาระบุขนาด (mm.)' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="fire_hydrant_code">{{ 'รหัสหัวจ่ายน้ำดับเพลิง' }} <span class="required-input">*</span></label>
                            <InputText id="firehydrant_code" type="text" disabled v-model="firehydrant_code" />
                            <!-- v-model="firehydrant_code" -->
                        </div>

                        <!-- Doe แก้ไข ซอย/ตรอก -->
                        <!-- <div class="p-field p-col-12 p-lg-6 p-mt-2">
              <label for="ifh_soi_name"
                >{{ 'ซอย' }}
                <span class="required-input"></span>
                </label
              >
              <InputText
                id="ifh_soi_name"
                type="text"
                v-model="ifh_soi_name"
                required="true"
                autofocus
                
              />
              

            </div> -->
                        <div class="p-field p-col-12 p-lg-6 p-mt-5">
                            <span hidden>{{ url }}</span>
                            <div class="p-grid">
                                <div class="p-col-8 p-lg-8">
                                    <Button
                                        @click="onFileChange"
                                        style="margin-top: 12px"
                                        class="p-button-success"
                                        icon="pi pi-plus"
                                        label="เลือกไฟล์ภาพ"
                                        ref="TextBox_2"
                                        @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                                    >
                                    </Button>
                                    <input
                                        style="visibility: hidden; display: none; text-overflow: ellipsis"
                                        type="file"
                                        id="fireHydrant_uploadImageFile"
                                        @change="onFileChange"
                                        class="inputzone"
                                        accept="image/*"
                                    />
                                </div>
                                <div class="p-col-4 p-lg-4">
                                    <Button
                                        @click="clearImage()"
                                        icon="pi pi-times"
                                        class="p-button-danger"
                                        style="width: auto; margin-top: 4.5px"
                                        :label="$t('clearImage')"
                                        ref="TextBox_3"
                                        @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                        @keyup.down="moveFocus($event, 'TextBox_6', 'Input')"
                                    />
                                </div>
                            </div>

                            <div id="preview">
                                <img v-if="resolveImageSrc(url)" :src="resolveImageSrc(url)" />
                            </div>
                            <div id="io_image" ref="io_image" hidden></div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid" style="display: flex">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="ifh_soi_name"
                                >{{ 'ซอย/ตรอก' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="ifh_soi_name"
                                type="text"
                                v-model="ifh_soi_name"
                                required="true"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="ira_location_name"
                                >{{ 'ถนน' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="ifh_road_name"
                                type="text"
                                v-model="ifh_road_name"
                                required="true"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ifh_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ifh_selectedProvince && !ifh_selectedProvince
                                }"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ifh_selectedProvince && !ifh_selectedProvince">{{ 'กรุณาระบุ จังหวัด' }}</small>
                        </div>
                    </div>
                    <!-- </div> -->

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledAmphur == 1"
                                v-model="ira_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedAmphur && !ira_selectedAmphur
                                }"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value">
                                        <div>{{ slotProps.value.amphur_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>
                                <template #option="slotProps">
                                    <div>{{ slotProps.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedAmphur && !ira_selectedAmphur">{{ 'กรุณาระบุ เขต/อำเภอ' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledTambon == 1"
                                v-model="ira_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedTambon && !ira_selectedTambon
                                }"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedTambon && !ira_selectedTambon">{{ 'กรุณาระบุ แขวง/ตำบล' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ifh_community_name"
                                >{{ 'ชุมชน' }}
                                <span class="required-input"></span>
                            </label>
                            <Dropdown
                                v-model="ifh_community_name"
                                :options="communityOptions"
                                optionLabel="community_name"
                                :dataKey="'community_id'"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value">
                                        <div>{{ slotProps.value.community_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>

                                <template #option="slotProps">
                                    <div class="EV_communityOptions">
                                        {{ slotProps.option.community_name }}
                                    </div>
                                </template>
                            </Dropdown>
                        </div>

                        <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2 " 
                            v-if="!ifh_selectedProvince &&
                                    !ira_selectedAmphur &&
                                    !ira_selectedTambon">
                                <label for="FireStationOptions">{{ $t("ira_FireStation") }}</label>
                                <span class="required-input"> *</span>
                                <Dropdown
                                
                                v-model="ifh_FireStationSelected"
                                :options="FireStationOptions"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ifh_FireStationSelected && !ifh_FireStationSelected
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                <template #value="FireStationOptions">
                                    <div v-if="FireStationOptions.value">
                                    <div>{{ FireStationOptions.value.fs_tname }}</div>
                                    </div>
                                </template>
                                <template #option="FireStationOptions">
                                    <div class=".EV_disasterOptions">{{ FireStationOptions.option.fs_tname }}</div>
                                </template>
                                </Dropdown>
                                <small
                                class="p-invalid"
                                v-if="error_ifh_FireStationSelected && !ifh_FireStationSelected"
                                >{{ 'กรุณาระบุ สถานีดับเพลิงและกู้ภัย' }}</small
                                >
                            </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2 " v-else> -->
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="FireStationOptions">{{ $t('ira_FireStation') }}</label>
                            <span class="required-input"> *</span>
                            <Dropdown
                                v-model="ifh_FireStationSelected"
                                :options="FireStationOptions_Form"
                                optionLabel="fs_tname"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ifh_FireStationSelected && !ifh_FireStationSelected
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <!-- @input="inputMap_PAT_latlon" -->
                                <template #value="FireStationOptions_Form">
                                    <div v-if="FireStationOptions_Form.value">
                                        <div>{{ FireStationOptions_Form.value.fs_tname }}</div>
                                    </div>
                                </template>
                                <template #option="FireStationOptions_Form">
                                    <div>{{ FireStationOptions_Form.option.fs_tname }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ifh_FireStationSelected && !ifh_FireStationSelected">{{
                                'กรุณาระบุ สถานีดับเพลิงและกู้ภัย'
                            }}</small>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="ifh_location">{{ 'ที่ตั้ง' }}<span class="required-input"></span></label>
                            <InputText
                                id="ifh_location"
                                type="text"
                                v-model="ifh_location"
                                required="true"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ifs_status"
                                >{{ 'สถานะ' }}
                                <span class="required-input">*</span>
                            </label>
                            <!-- <InputText
                    id="ifs_status"
                    type="text"
                    v-model="ifs_status"
                    required="true"
                    autofocus
                    
                  /> -->
                            <Dropdown
                                id="ifs_status"
                                v-model="ifs_status"
                                :options="status_Options"
                                optionLabel=""
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ifh_status && !ifs_status
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                appendTo="body"
                            >
                                <template #value="status_Options">
                                    <div v-if="status_Options.value">
                                        <div>{{ status_Options.value }}</div>
                                    </div>
                                </template>
                                <template #option="status_Options">
                                    <div>{{ status_Options.option }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ifh_status && !ifs_status">{{ 'กรุณาระบุ สถานะ' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ifs_inspec_details"
                                >{{ 'รายละเอียดการตรวจสอบ' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="ifs_inspec_detailss"
                                type="text"
                                v-model="ifs_inspec_details"
                                required="true"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="ifs_inspec_result"
                                >{{ 'ผลการดำเนินงาน' }}
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="ifs_inspec_result"
                                type="text"
                                v-model="ifs_inspec_result"
                                required="true"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lat">{{ $t('lat') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lat"
                                type="text"
                                v-model="ifh_lat"
                                @input="handleInput"
                                :class="{
                                    'p-invalid': (error_ifh_lat && !ifh_lat) || error_ifh_lat_dot
                                }"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ifh_lat && !ifh_lat">{{ 'กรุณาระบุ ค่าละติจูด' }}</small>
                            <small class="p-invalid" v-if="error_ifh_lat_dot">{{ 'ค่าละติจูด ต้องเป็น 13.XXXXXX' }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ifh_lon">{{ $t('lon') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="ifh_lon"
                                type="text"
                                v-model="ifh_lon"
                                @input="handleInput"
                                :class="{
                                    'p-invalid': error_ifh_lon && !ifh_lon
                                }"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                                pattern="^\\d{3}(\\.\\d{6})?$"
                            />
                            <small class="p-invalid" v-if="error_ifh_lon && !ifh_lon">{{ 'กรุณาระบุ ค่าลองจิจูด' }}</small>
                            <small class="p-invalid" v-if="error_ifh_lon_dot">{{ 'ค่าลองจิจูด ต้องเป็น 100.XXXXXX' }}</small>
                        </div>

                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->

                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(ifh_lat, ifh_lon);
                                    sendM_PAT(ira_selectedTambon, ira_selectedAmphur, ifh_selectedProvince, ifh_FireStationSelected);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->
                </div>
            </div>

            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_12"
                    @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_12"
                    @keyup.left="moveFocus($event, 'TextBox_11', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_13"
                    @keyup.left="moveFocus($event, 'TextBox_12', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->

        <div id="qrCodeContainer" class="qr-container" style="z-index: -10; display: none; position: absolute; top: 0; left: 0">
            <img id="qrCodeImage" alt="QR Code" class="qr-code" />
            <div class="code-label">{{ code }}</div>
        </div>
    </div>
</template>

<script>
import mapArea from '../Map';

import QRCode from 'qrcode';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

// import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-risk-area',
    components: {
        mapArea
        // textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            community_name: null,
            communityOptions: [],
            dropdownClearFilerValue: 0,
            loading: false,

            searchResults: [], // Store full search results
            currentPage: 1,
            isSearchMode: false,

            lazyParams: {
                first: 0,
                rows: 50, // Default to match your current rows
                page: 1,
                totalRecords: 0
            },

            firehydrant: null,
            columns_code: true,

            table_genQR: window.innerWidth > 700 ? this.$i18n.t('qrCodeBtn') : '',

            fire_hydrant_code: '',
            firehydrant_code: '',
            columns_genqr: true,
            code: '',

            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/6
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,
            manageInstallingFirehydrant: false,

            FireHydrant_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            // Doe เพิ่ม สถานีดับเพลิงและกู้ภัย
            FireStationOptions: [],
            FireStationSelected: null,
            error_FireStation: false,
            FireStationOptions_AT: [],
            FireStationOptions_Form: [],

            // ifh_FireStationOptions:[],
            ifh_FireStationSelected: null,
            error_ifh_FireStationSelected: false,

            // Doe ชุมชน
            ifh_community_name: null,
            error_ifh_community: false,

            ifh_soi_name: '',
            soi_name: '',

            pipe_size: '',
            ifh_firehydrant_code: '',
            ifh_firehydrant_result: '' /*#R*/,
            road_name: '',
            ifh_pipe_size: '',
            ifh_road_name: '',
            FireStation_sel: false,
            i: 0,

            ifh_location: '',

            // img
            url: null,
            imgTable: null,
            displayBasic2: false,

            filters: {},
            temp: null,
            showOrganize: false,
            selectedFireHydrant: [],
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,

            riskLevelOptions: [],
            riskLevelSelected: null,

            header: this.$i18n.t('ifh_modal_title_add'),
            selectedData: '',

            Dropdown_Fire_type: '',
            Dropdown_Fire_boundary: '',
            Dropdown_Fire_id: '',

            FireHydrantModal: false,
            ira_location_name: '',
            ira_location_detail: '',
            ira_selectedOrganize: {},
            ifh_selectedProvince: null,
            ira_selectedAmphur: null,
            ira_selectedTambon: null,
            ira_isDisabledAmphur: 1,
            ira_isDisabledTambon: 1,
            ira_disasterTypeSelected: null,
            ira_riskLevelSelected: null,
            ifh_lat: '',
            ifh_lon: '',
            imageName: '',

            error_ifh_selectedProvince: false,
            error_ira_selectedAmphur: false,
            error_ira_selectedTambon: false,
            error_ira_selectedOrganize: false,
            error_ira_location_name: false,
            error_ira_selectedDisaster: false,

            error_fire_hydrant_code: false,

            error_ifh_pipe_size: false,
            error_ifh_road_name: false,
            error_ifh_status: false,
            error_ifh_lat: false,
            error_ifh_lat_dot: false,
            error_ifh_lon: false,
            error_ifh_lon_dot: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            status: null,
            status_Options_Search: ['เลือกทั้งหมด', 'ปกติ', 'ชำรุด', 'ระหว่างติดตั้ง'],
            status_Options: ['ปกติ', 'ชำรุด', 'ระหว่างติดตั้ง'],
            ifs_status: null,

            inspec_details: '',
            ifs_inspec_details: '',
            ifs_inspec_result: '' /*#R*/,
            inspec_result: '',
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            FSS: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            iP: 0,
            iA: 0,

            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ขนาด',
                    textShow: ''
                },
                {
                    DataName: 'ซอย/ตรอก',
                    textShow: ''
                },
                {
                    DataName: 'ถนน',
                    textShow: ''
                },
                {
                    DataName: 'ชุมชน',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                },
                {
                    DataName: 'สถานีดับเพลิงและกู้ภัย',
                    textShow: ''
                },
                {
                    DataName: 'ที่ตั้ง',
                    textShow: ''
                },
                {
                    DataName: 'สถานะ',
                    textShow: ''
                },
                {
                    DataName: 'รายละเอียดการตรวจสอบ',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลหัวจ่ายน้ำดับเพลิง',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 10, right: 10 },

            PDF_minCellWidthVer: 45,
            PDF_FontHeaderVer: 7,
            PDF_FontBodyVer: 5,

            PDF_BodySizeSelect: {},
            // PDF_BodySize:{
            //                 index: {cellWidth: 21},
            //                 pipe_size: {cellWidth: 35},
            //                 soi_name:{cellWidth:40},
            //                 road_name:{cellWidth:40},
            //                 // inspec_details:{cellWidth:58},
            //                 fire_station:{cellWidth:53},
            //                 location:{cellWidth:50},
            //                 inspec_details:{cellWidth:40},
            //                 status:{cellWidth:28},
            //                 // event_lat:{cellWidth:35},
            //                 // event_lon:{cellWidth:35}
            //                 event_latPDF:{cellWidth:28},
            //                 event_lonPDF:{cellWidth:28},

            //                 date_update_ddmmyy:{cellWidth:50}
            // },
            PDF_BodySize: {
                index: { cellWidth: 21 },
                pipe_size: { cellWidth: 23 },
                soi_name: { cellWidth: 36 },
                road_name: { cellWidth: 40 },
                tambon_name: { cellWidth: 36 },
                fire_station: { cellWidth: 53 },
                location: { cellWidth: 35 },
                inspec_details: { cellWidth: 40 },
                inspec_result: { cellWidth: 23 },
                status: { cellWidth: 28 },
                amphur_name: { cellWidth: 36 },
                event_lat: { cellWidth: 35 },
                event_lon: { cellWidth: 35 },
                community_name: { cellWidth: 38 },
                event_latPDF: { cellWidth: 28 },
                event_lonPDF: { cellWidth: 28 },
                province_name: { cellWidth: 32 },
                date_create_ddmmyy: { cellWidth: 40 },
                date_update_ddmmyy: { cellWidth: 46 }
            },
            isSelectAll: false,
            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 10,
            PDF_FontBodyHor: 8,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                pipe_size: { cellWidth: 40 },
                // soi_name:{cellWidth:50},
                // road_name:{cellWidth:50},
                // community_name:{cellWidth:50},
                inspec_details: { cellWidth: 52 },
                inspec_result: { cellWidth: 30 },
                // event_lat:{cellWidth:40},

                status: { cellWidth: 40 },
                event_latPDF: { cellWidth: 40 },
                event_lonPDF: { cellWidth: 40 },

                date_create_ddmmyy: { cellWidth: 55 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                // {title: "ขนาดของหัวจ่ายน้ำดับเพลิง (mm.)", dataKey: "pipe_size" },
                // {title: "รูปภาพ" ,dataKey:"image"},
                { title: 'ขนาด (mm.)', dataKey: 'pipe_size' },
                { title: 'ผลการดำเนินการ', dataKey: 'inspec_result' },
                { title: 'ซอย/ตรอก', dataKey: 'soi_name' },
                { title: 'ถนน', dataKey: 'road_name' },
                { title: 'ชุมชน', dataKey: 'community_name' },
                { title: 'สถานีดับเพลิงและกู้ภัย', dataKey: 'fire_station' },
                { title: 'ที่ตั้ง', dataKey: 'location' },
                { title: 'แขวง/ตำบล', dataKey: 'tambon_name' },
                { title: 'เขต/อำเภอ', dataKey: 'amphur_name' },
                { title: 'จังหวัด', dataKey: 'province_name' },
                { title: 'สถานะ', dataKey: 'status' },
                { title: 'รายละเอียดการตรวจสอบ', dataKey: 'inspec_details' },
                // {title: "ละติจูด", dataKey: "event_lat"},
                // {title: "ลองจิจูด", dataKey: "event_lon"},
                { title: 'ละติจูด', dataKey: 'event_latPDF' },
                { title: 'ลองจิจูด', dataKey: 'event_lonPDF' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' },
                { title: 'ผู้สร้างข้อมูล', dataKey: 'create_by_fullname' },
                { title: 'ผู้ปรับปรุงข้อมูล', dataKey: 'edit_by_fullname' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_img_cloud: true,
            columns_index: true,
            columns_pipe_size: true,
            columns_img: true,
            columns_soi_name: true,
            columns_road_name: true,
            columns_community_name: true,
            columns_fire_station: true,
            columns_location: true,
            columns_tambon_name: true,
            columns_amphur_name: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,
            columns_fire_hydrant_detail: true,
            columns_status: true,
            columns_inspec_details: true,
            columns_inspec_result: true,
            GetData_ColumnsSearch: [],

            columns_date_create: true,
            columns_date_update: true,
            columns_create_by_fullname: true,
            columns_edit_by_fullname: true,

            columns_disabled: true,

            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: 'แนวตั้ง',
                    command: async () => {
                        try {
                            await this.searchAllFireHydrant();
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'image';
                            });

                            const Body_setCenter = [
                                'index',
                                'tambon_name',
                                'amphur_name',
                                'province_name',
                                'event_latPDF',
                                'event_lonPDF',
                                'status',
                                'pipe_size'
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.searchAllFireHydrant();
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns = this.columnsSelector;
                            columns = columns.filter(function (item) {
                                return item.dataKey != 'image';
                            });

                            const Body_setCenter = [
                                'index',
                                'tambon_name',
                                'amphur_name',
                                'province_name',
                                'event_latPDF',
                                'event_lonPDF',
                                'status',
                                'pipe_size'
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF', life: 3000 });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ],

            FireStationOptions_Form_main: []
            // Doe : PDF 3/3 จบ
        };
    },

    watch: {
        filter(newVal) {
            if (!newVal?.trim()) {
                this.isSearchMode = false;
            }
        },

        async FireHydrantModal(val) {
            if (val) {
                // When opening modal
                try {
                    const provinceResponse = await this.axios.post(`${this.$url_service}/general/country`, { body: { topic: 'get-province' } });
                    this.provinceOptions = provinceResponse.data.data;

                    const fsResponse = await this.axios.post(`${this.$url_service}/initial/firestation`, {
                        body: {
                            topic: 'get-option-firestation',
                            userData: this.getUser()
                        }
                    });
                    this.FireStationOptions = fsResponse.data.data;

                    if (this.temp === null) {
                        const today = new Date();
                        this.date_create_form = today.toLocaleDateString('th-TH', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        });
                        this.date_update_form = this.date_create_form;
                    }

                    // Check fire form search only if no selected data
                    if (!this.selectedData) {
                        await this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', false);
                    }
                } catch (error) {
                    console.error('Error initializing modal:', error);
                }
            } else {
                // When closing modal
                this.clearData();
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.FireHydrantModal = true;
            }
        },

        async selectedData(val) {
            if (!val) return;

            try {
                if (val.location_id === 'null') {
                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                    return;
                }

                // First set province and wait for its options to load
                this.ifh_selectedProvince = {
                    province_id: val.province_id,
                    province_name: val.province_name
                };

                // Wait for province watcher to complete
                await this.$nextTick();

                // Load amphur options
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: val.province_id
                        }
                    })
                    .then((response) => {
                        this.amphurOptions = response.data.data;

                        // Now set amphur
                        this.ira_selectedAmphur = {
                            amphur_id: val.amphur_id,
                            amphur_name: val.amphur_name
                        };
                    });

                // Wait for amphur watcher
                // await this.$nextTick();

                // Load tambon options
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: val.amphur_id
                        }
                    })
                    .then((response) => {
                        this.tambonOptions = response.data.data;

                        // Finally set tambon
                        this.ira_selectedTambon = {
                            tambon_id: val.location_id,
                            tambon_name: val.tambon_name
                        };
                    });

                // Load community options

                // await this.$nextTick();

                await this.axios
                    .post(`${this.$url_service}/initial/community/option-1`, {
                        body: {
                            amphur: this.ira_selectedAmphur ? this.ira_selectedAmphur.amphur_name : null
                        }
                    })
                    .then((response) => {
                        this.communityOptions = response.data.data;

                        // Finally set tambon
                        this.ifh_community_name = {
                            community_id: val.community_id || '',
                            community_name: val.community_name
                        };
                    });

                await this.$nextTick();

                // Load fire station
                await this.axios
                    .post(`${this.$url_service}/initial/firestation`, {
                        body: {
                            topic: 'get-option-firestation',
                            userData: this.getUser()
                        }
                    })
                    .then((response) => {
                        this.FireStationOptions = response.data.data;

                        // Finally set tambon
                        this.ifh_FireStationSelected = {
                            fs_tname: val.fire_station
                        };
                    });
            } catch (error) {
                console.error('Error in selectedData watcher:', error);
            }
        },

        async selectedProvince(val) {
            // this.FireStationSelected = null
            this.communitySelect = null;
            this.selectedAmphur = null;

            if (val != null) {
                this.isDisabledAmphur = 0;
                // console.log(this.selectedProvince.province_id)
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
                await this.initialCommunityData();

                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            }
        },
        async selectedAmphur(val) {
            // this.FireStationSelected = null
            this.communitySelect = null;
            this.selectedTambon = null;

            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
                await this.updateCommunityOptions(val.amphur_name);
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
                // this.FireStationSelected = null
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
                await this.initialCommunityData();
            }
        },
        async selectedTambon(val) {
            // this.FireStationSelected =null
            if (val != null) {
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            } else {
                this.selectedTambon = null;
                // this.FireStationSelected =null
                this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);
            }
        },
        async ifh_selectedProvince(val) {
            this.ifh_community_name = null;
            this.ira_selectedAmphur = null;

            if (val != null) {
                this.ira_isDisabledAmphur = 0;
                if (this.iP != 0) {
                    // this.ifh_FireStationSelected = null
                }
                this.iP++;

                // await this.axios
                //     .post(`${this.$url_service}/general/country`, {
                //         body: {
                //             topic: 'get-amphur',
                //             province_id: this.ifh_selectedProvince.province_id
                //         }
                //     })
                //     .then((response) => {
                //         // console.log(response)
                //         this.amphurOptions = response.data.data;
                //     });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.ifh_selectedProvince.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                this.ira_isDisabledAmphur = 1;
                this.ira_selectedAmphur = null;
                await this.initialCommunityData();
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            }
        },

        async ira_selectedAmphur(val) {
            this.ifh_community_name = null;
            if (val != null) {
                this.ira_isDisabledTambon = 0;
                if (this.iA != 0) {
                    // this.ifh_FireStationSelected = null
                }
                this.iA++;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.ira_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
                // this.Fire_Form()
                await this.updateCommunityOptions(val.amphur_name);
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                this.ira_isDisabledTambon = 1;
                this.ira_selectedTambon = null;
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
                await this.initialCommunityData();
            }
        },

        async ira_selectedTambon(val) {
            if (val != null) {
                // console.log("this.selectedData.tambon_name",this.selectedData.tambon_name)
                // console.log("val.tambon_name",val.tambon_name)
                if (this.selectedData.tambon_name !== val.tambon_name) {
                    this.ifh_FireStationSelected = null;
                }

                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            } else {
                // this.ifh_FireStationSelected = null
                // this.Fire_Form()
                this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.FireHydrant_Table = [];
            } else {
                this.FireHydrant_Table = this.cloneTable;
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            this.searchMenu();
        } else {
            this.ms = true;
            this.searchMenu();
            // this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // for (let index = 0; index < this.columnsSelector.length; index++) {
        //     this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        // }

        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        permissionEnabled(value) {
            return value === true || value === 'true';
        },
        firehydrantAuthOptions() {
            return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
        },
        async loadFirehydrantPermissions() {
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/firehydrant`, {
                    body: { topic: 'get-firehydrant-permissions' }
                }, this.firehydrantAuthOptions());
                this.manageInstallingFirehydrant = this.permissionEnabled(response.data.manage_installing_firehydrant);
                this.checkEdit_data = response.data.edit_data;
                this.checkDelete_data = response.data.delete_data;
            } catch (error) {
                this.manageInstallingFirehydrant = false;
                this.checkEdit_data = false;
                this.checkDelete_data = false;
            }
        },
        async postFirehydrantMutation(url, payload) {
            try {
                return await this.axios.post(url, payload, this.firehydrantAuthOptions());
            } catch (error) {
                this.loadingCreate = false;
                await this.loadFirehydrantPermissions();
                this.$fire({ type: 'error', title: 'ไม่สามารถจัดการข้อมูลได้',
                    text: (error.response && error.response.data && error.response.data.message) || 'กรุณาลองใหม่อีกครั้ง' });
                throw error;
            }
        },

        handleLatInput() {
            if (this.ifh_lat) {
                // Format to exactly 6 decimal places
                this.ifh_lat = parseFloat(this.ifh_lat).toFixed(6);
                // Validate format (should be around 13.xxxxxx for Thailand)
                if (!/^1[3-4]\.\d{6}$/.test(this.ifh_lat)) {
                    this.error_ifh_lat_dot = true;
                } else {
                    this.error_ifh_lat_dot = false;
                    this.error_ifh_lat = false;
                    // Only try to update location data if both coordinates are valid
                    if (this.ifh_lon && /^100\.\d{6}$/.test(this.ifh_lon)) {
                        this.inputMap_latlon();
                    }
                }
            }
        },

        handleLonInput() {
            if (this.ifh_lon) {
                // Format to exactly 6 decimal places
                this.ifh_lon = parseFloat(this.ifh_lon).toFixed(6);
                // Validate format (should be around 100.xxxxxx for Thailand)
                if (!/^100\.\d{6}$/.test(this.ifh_lon)) {
                    this.error_ifh_lon_dot = true;
                } else {
                    this.error_ifh_lon_dot = false;
                    this.error_ifh_lon = false;
                    // Only try to update location data if both coordinates are valid
                    if (this.ifh_lat && /^1[3-4]\.\d{6}$/.test(this.ifh_lat)) {
                        this.inputMap_latlon();
                    }
                }
            }
        },
        async initialCommunityData() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.ira_selectedAmphur
                        ? this.ira_selectedAmphur.amphur_name
                        : this.selectedAmphur
                        ? this.selectedAmphur.amphur_name
                        : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching community options:', error);
            } finally {
                this.loading = false;
            }
        },

        async updateCommunityOptions() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option-1`, {
                    amphur: this.ira_selectedAmphur
                        ? this.ira_selectedAmphur.amphur_name
                        : this.selectedAmphur
                        ? this.selectedAmphur.amphur_name
                        : null
                });
                this.communityOptions = response.data.data;
            } catch (error) {
                console.error('Error fetching filtered community options:', error);
            } finally {
                this.loading = false;
            }
        },

        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedFireHydrant.map((item) => ({
                    firehydrant_id: item.firehydrant_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.postFirehydrantMutation(`${this.$url_service}/initial/firehydrant?user=${userId}`, {
                    body: {
                        topic: 'edit-firehydrant_date_multiple',
                        selectedFireHydrant: formattedRecords,
                        userOrg: userOrg,
                        userId: userId,
                        isSelectAll: this.isSelectAll,
                        pipe_size: this.pipe_size,
                        ifh_firehydrant_code: this.ifh_firehydrant_code,
                        soi_name: this.soi_name,
                        road_name: this.road_name,
                        community_name: this.community_name !== null ? this.community_name.community_name : '',
                        province: this.selectedProvince,
                        userData: this.getUser(),
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        level: this.riskLevelSelected,
                        fire_station:
                            this.FireStationSelected == null
                                ? ''
                                : this.FireStationSelected.fs_tname == this.$i18n.t('selectAll')
                                ? ''
                                : this.FireStationSelected.fs_tname,
                        location: this.ifh_location,
                        status: this.status == null ? '' : this.status == this.$i18n.t('selectAll') ? '' : this.status,
                        inspec_details: this.inspec_details,
                        inspec_result: this.inspec_result,
                        organizeName: this.getOrganize_name()
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.FireHydrantModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลหัวจ่ายน้ำดับเพลิงจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchFireHydrant();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            this.isSelectAll = true;
            if (checked) {
                this.selectedFireHydrant = [...this.FireHydrant_Table];
            } else {
                this.isSelectAll = false;
                this.selectedFireHydrant = [];
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        onSelectRow(row, checked) {
            this.isSelectAll = false;
            if (checked) {
                if (!this.selectedFireHydrant.some((item) => item.firehydrant_id === row.firehydrant_id)) {
                    this.selectedFireHydrant.push(row);
                }
            } else {
                this.selectedFireHydrant = this.selectedFireHydrant.filter((item) => item.firehydrant_id !== row.firehydrant_id);
            }
            this.$emit('selectedFireHydrant', this.selectedFireHydrant);
            // console.log('selectedFireHydrant', this.selectedFireHydrant);
        },

        chackDisableType() {
            if (this.temp) {
                return true;
            } else {
                return false;
            }
        },

        getUser1() {
            const getUser = localStorage.getItem('data');
            if (typeof getUser == 'string') {
                return JSON.parse(getUser);
            }
            return getUser;
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        getUser() {
            const getUser = this.decodeJWT(localStorage.getItem('token'));
            if (typeof getUser == 'string') {
                return JSON.parse(getUser);
            }
            return getUser;
        },
        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_6_search') && !this.isFocused('TextBox_7_search')) {
                    // this.searchFireHydrant()
                    this.fastSearchFireHydrant();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_10') &&
                    !this.isFocused('TextBox_11') &&
                    !this.isFocused('TextBox_12')
                ) {
                    this.saveData();
                }
            }
        },
        async exportCSV() {
            await this.searchAllFireHydrant();
            this.$refs.dt.exportCSV();
        },

        async Fire_Form_search(status) {
            if (this.ifh_lon != '') {
                return;
            }

            // Load fire station options if not already loaded
            if (!this.FireStationOptions_Form_main.length) {
                await this.Fire_Form();
            }

            if (status == 'search') {
                // Set FireStationOptions_AT without adding "selectAll" if it already exists
                this.FireStationOptions_AT = [...this.FireStationOptions_Form_main];

                // Add "selectAll" option only if it doesn't already exist
                if (
                    this.FireStationOptions_AT.length > 0 &&
                    !this.FireStationOptions_AT.some((option) => option.fs_tname === this.$i18n.t('selectAll'))
                ) {
                    this.FireStationOptions_AT.unshift({
                        fs_tname: this.$i18n.t('selectAll')
                    });
                }
            }

            this.FireStationOptions_Form = this.FireStationOptions_Form_main;
            return;
        },

        check_Fire_Form_search(Tambon, Amphur, Province, status, clear) {
            if (Tambon !== null && Amphur !== null && Province !== null) {
                if (Tambon.tambon_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else if (Amphur.amphur_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'amphoe';
                        this.Dropdown_Fire_id = Amphur.amphur_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'tambon';
                    this.Dropdown_Fire_id = Tambon.tambon_id;
                }
            } else if (Amphur !== null && Province !== null) {
                if (Amphur.amphur_id === 'getall') {
                    if (Province.province_id === 'getall') {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'all';
                        this.Dropdown_Fire_id = '';
                    } else {
                        this.Dropdown_Fire_type = '';
                        this.Dropdown_Fire_boundary = 'province';
                        this.Dropdown_Fire_id = Province.province_id;
                    }
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'amphoe';
                    this.Dropdown_Fire_id = Amphur.amphur_id;
                }
            } else if (Province !== null) {
                if (Province.province_id === 'getall') {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'all';
                    this.Dropdown_Fire_id = '';
                } else {
                    this.Dropdown_Fire_type = '';
                    this.Dropdown_Fire_boundary = 'province';
                    this.Dropdown_Fire_id = Province.province_id;
                }
            } else {
                this.Dropdown_Fire_type = '';
                this.Dropdown_Fire_boundary = 'all';
                this.Dropdown_Fire_id = '';
            }

            if (status === 'search') {
                if (clear === true) {
                    this.FireStationSelected = null;
                }

                this.Fire_Form_search(status);
            } else {
                if (this.selectedData == '') {
                    this.ifh_FireStationSelected = null;
                } else if (Tambon === null || Amphur === null || Province === null) {
                    this.ifh_FireStationSelected = null;
                }
                this.Fire_Form_search(status);
            }
        },
        async Fire_Form() {
            if (this.selectedData == '') {
                // this.ifh_FireStationSelected = null
            }

            // this.selectedProvince = null
            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        // province_id:this.ifh_selectedProvince == null ? "" :
                        // this.ifh_selectedProvince.province_id == "getall" ? ""
                        // : this.ifh_selectedProvince.province_id,
                        // amphur_id:this.ira_selectedAmphur == null ? "" :
                        // this.ira_selectedAmphur.amphur_id == "getall" ? ""
                        // : this.ira_selectedAmphur.amphur_id,
                        // tambon_id:this.ira_selectedTambon == null ? "" :
                        // this.ira_selectedTambon.tambon_id == "getall" ? ""
                        // : this.ira_selectedTambon.tambon_id
                        province_id: '',
                        amphur_id: '',
                        userData: this.getUser1(),
                        tambon_id: ''
                    }
                })
                .then((response) => {
                    this.FireStationOptions_Form = response.data.data;
                    this.FireStationOptions_Form_main = response.data.data;
                    // console.log("this.FireStationOptions_AT",this.FireStationOptions_AT)
                });
        },
        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            this.table_genQR = window.innerWidth > 700 ? this.$i18n.t('qrCodeBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    (this.FireStationOptions = response.data.data),
                        this.FireStationOptions.splice(0, 0, {
                            fs_id: 'getall',
                            fs_tname: this.$i18n.t('selectAll')
                        });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
        },

        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(async () => {
                try {
                    if (!this.filter?.trim()) {
                        this.isSearchMode = false;
                        return await this.fastSearchFireHydrant();
                    }

                    this.error = null;
                    this.isSearchMode = true;
                    this.loading = true;

                    const searchFields = [
                        { enabled: this.columns_pipe_size, field: 'pipe_size' },
                        { enabled: this.columns_code, field: 'code' },
                        { enabled: this.columns_road_name, field: 'road_name' },
                        { enabled: this.columns_soi_name, field: 'soi_name' },
                        { enabled: this.columns_fire_station, field: 'fire_station' },
                        { enabled: this.columns_community_name, field: 'community_name' },
                        { enabled: this.columns_status, field: 'status' },
                        { enabled: this.columns_inspec_details, field: 'inspec_details' },
                        { enabled: this.columns_inspec_result, field: 'inspec_result' },
                        { enabled: this.columns_date_create, field: 'date_create' },
                        { enabled: this.columns_date_update, field: 'date_update' },
                        { enabled: this.columns_location, field: 'location_id' },
                        { enabled: this.columns_tambon_name, field: 'fh_tambon_name' },
                        { enabled: this.columns_amphur_name, field: 'fh_amphur_name' },
                        { enabled: this.columns_province_name, field: 'fh_province_name' },
                        { enabled: this.columns_event_lat, field: 'event_lat' },
                        { enabled: this.columns_event_lon, field: 'event_lon' }
                    ]
                        .filter(({ enabled }) => enabled)
                        .map(({ field }) => field);

                    if (!searchFields.length) {
                        this.error = 'Please enable at least one search column';
                        return;
                    }

                    const organizeName = this.getOrganize_name();

                    const response = await this.axios.post(`${this.$url_service}/initial/firehydrant`, {
                        body: {
                            topic: 'filter-table',
                            filter: this.filter,
                            fields: searchFields,
                            pagination: {
                                page: this.lazyParams.page || 1,
                                limit: this.lazyParams.rows || 10
                            },
                            userData: this.getUser(),
                            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                            organizeName
                        }
                    });

                    if (response.data) {
                        const data = response.data.data || [];
                        const startIndex = (this.lazyParams.page - 1) * this.lazyParams.rows;

                        // Process each item to format data
                        data.forEach((item, index) => {
                            // Create index starting from current page
                            item.index = startIndex + index + 1;

                            // Format date fields properly

                            // Date create formatting
                            if (item.date_create) {
                                const formattedDate = this.changeDateToThai(this.checkDate(item.date_create));
                                item.date_create_ddmmyy = formattedDate !== 'Invalid Date' ? formattedDate : '-';
                            } else {
                                item.date_create_ddmmyy = '-';
                            }

                            // Date update formatting
                            if (item.date_update) {
                                const formattedDate = this.changeDateToThai(this.checkDate(item.date_update));
                                item.date_update_ddmmyy = formattedDate !== 'Invalid Date' ? formattedDate : '-';
                            } else {
                                item.date_update_ddmmyy = '-';
                            }

                            // Handle other fields as before
                            if (item.event_lat && item.event_lat !== '-') {
                                item.event_latPDF = parseFloat(item.event_lat).toFixed(6);
                            } else {
                                item.event_latPDF = '-';
                            }

                            if (item.event_lon && item.event_lon !== '-') {
                                item.event_lonPDF = parseFloat(item.event_lon).toFixed(6);
                            } else {
                                item.event_lonPDF = '-';
                            }

                            // Format other fields with standardized handling
                            const fieldsToCheck = [
                                'road_name',
                                'soi_name',
                                'fire_station',
                                'location',
                                'tambon_name',
                                'amphur_name',
                                'province_name',
                                'community_name',
                                'status',
                                'inspec_details',
                                'inspec_result'
                            ];

                            fieldsToCheck.forEach((field) => {
                                if (item[field] === null || item[field] === 'null' || item[field] === '') {
                                    item[field] = '-';
                                }
                            });
                        });

                        this.FireHydrant_Table = data;
                        this.cloneTable = data;
                        this.lazyParams.totalRecords = Number(response.data.total);
                    }

                    this.currentPage = this.lazyParams.page;

                    // Apply column filters if needed
                    if (this.columns_disabled === true) {
                        this.FireHydrant_Table = this.cloneTable;
                    } else {
                        this.FireHydrant_Table = [];
                    }
                } catch (error) {
                    console.error('Error fetching filtered data:', error);
                    this.error = 'Failed to fetch data. Please try again.';
                    this.isSearchMode = false;
                    await this.fastSearchFireHydrant();
                } finally {
                    this.loading = false;

                    // Restore focus to input element after rendering completes
                    this.$nextTick(() => {
                        if (this.searchInputRef) {
                            this.searchInputRef.focus();

                            // Place cursor at the end of the text if needed
                            if (this.searchInputRef.value) {
                                const length = this.searchInputRef.value.length;
                                this.searchInputRef.setSelectionRange(length, length);
                            }
                        }
                    });
                }
            }, 400); // 400ms delay before sending API request
        },
        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            // console.log("4444")
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'get-table-firehydrant',
                        userData: this.getUser(),
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.FireHydrant_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.FireHydrant_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });

            this.check_Fire_Form_search(this.selectedTambon, this.selectedAmphur, this.selectedProvince, 'search', true);

            await this.axios
                .post(`${this.$url_service}/initial/firestation`, {
                    body: {
                        topic: 'get-option-firestation',
                        userData: this.getUser()
                    }
                })
                .then((response) => {
                    (this.FireStationOptions = response.data.data),
                        this.FireStationOptions.splice(0, 0, {
                            fs_id: 'getall',
                            fs_tname: this.$i18n.t('selectAll')
                        });
                    // console.log("this.FireStationOptions",this.FireStationOptions)
                });
            this.loading = false;
        },
        formatData(data) {
            if (data && data.length) {
                const startIndex = (this.lazyParams.page - 1) * this.lazyParams.rows;
                // console.log(data)
                for (let index = 0; index < data.length; index++) {
                    data[index]['index'] = startIndex + index + 1;
                    if (data[index].road_name == null || data[index].road_name == 'null' || data[index].road_name == '') {
                        data[index].road_name = '-';
                    }
                    if (data[index].soi_name == null || data[index].soi_name == 'null' || data[index].soi_name == '') {
                        data[index].soi_name = '-';
                    }
                    if (data[index].fire_station == null || data[index].fire_station == 'null' || data[index].fire_station == '') {
                        data[index].fire_station = '-';
                    }
                    if (data[index].location == null || data[index].location == 'null' || data[index].location == '') {
                        data[index].location = '-';
                    }
                    if (data[index].tambon_name == null || data[index].tambon_name == 'null' || data[index].tambon_name == '') {
                        data[index].tambon_name = '-';
                    }
                    if (data[index].amphur_name == null || data[index].amphur_name == 'null' || data[index].amphur_name == '') {
                        data[index].amphur_name = '-';
                    }
                    if (data[index].province_name == null || data[index].province_name == 'null' || data[index].province_name == '') {
                        data[index].province_name = '-';
                    }
                    if (data[index].community_name == null || data[index].community_name == 'null' || data[index].community_name == '') {
                        data[index].community_name = '-';
                    }
                    if (data[index].status == null || data[index].status == 'null' || data[index].status == '') {
                        data[index].status = '-';
                    }
                    if (data[index].inspec_details == null || data[index].inspec_details == 'null' || data[index].inspec_details == '') {
                        data[index].inspec_details = '-';
                    }
                    if (data[index].inspec_result == null || data[index].inspec_result == 'null' || data[index].inspec_result == '') {
                        data[index].inspec_result = '-';
                    }
                    if (data[index].event_lat == null || data[index].event_lat == 'null' || data[index].event_lat == '') {
                        data[index].event_lat = '-';
                        data[index]['event_latPDF'] = '-';
                    } else if (data[index].event_lat !== '-') {
                        data[index]['event_latPDF'] = parseFloat(data[index].event_lat).toFixed(6);
                    }
                    if (data[index].event_lon == null || data[index].event_lon == 'null' || data[index].event_lon == '') {
                        data[index].event_lon = '-';
                        data[index]['event_lonPDF'] = '-';
                    } else if (data[index].event_lon !== '-') {
                        data[index]['event_lonPDF'] = parseFloat(data[index].event_lon).toFixed(6);
                    }

                    if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                        data[index].date_create_ddmmyy = '-';
                    } else {
                        data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                    }

                    if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                        data[index].date_update_ddmmyy = '-';
                    } else {
                        data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                    }
                }
            }
        },

        onFileChange(e) {
            document.getElementById('fireHydrant_uploadImageFile').click();

            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    //  let imgSize = e.target.files[0]
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //         type: "warning",
                    //         title:"ขนาดไฟล์ใหญ่เกินไป",
                    //         text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //         timer: 3000,
                    //         confirmButtonColor: '#28B463',
                    //       });
                    //       this.clearImage()
                    // }else{
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.imageName = file.name;
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('io_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('fireHydrant_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('fireHydrant_uploadImageFile').value = '';
        },

        showImage(data) {
            const resolved = this.resolveImageSrc(data);
            if (!resolved) {
                this.imgTable = null;
            } else {
                this.imgTable = [resolved];
            }
            this.displayBasic2 = true;
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.FireHydrantModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.ira_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.ira_selectedTambon = null;
            }
        },
        acceptNumberPhone() {
            var x = this.ifh_pipe_size.replace(/\D/g, '');
            this.ifh_pipe_size = x;
        },
        async searchFireHydrant() {
            this.columns_img_cloud = false;
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'search-table-firehydrant',
                        pipe_size: this.pipe_size,
                        soi_name: this.soi_name,
                        road_name: this.road_name,
                        community_name: this.community_name,
                        userData: this.getUser(),
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        level: this.riskLevelSelected,
                        fire_station:
                            this.FireStationSelected == null
                                ? ''
                                : this.FireStationSelected.fs_tname == this.$i18n.t('selectAll')
                                ? ''
                                : this.FireStationSelected.fs_tname,
                        location: this.ifh_location,
                        status: this.status == null ? '' : this.status == this.$i18n.t('selectAll') ? '' : this.status,
                        inspec_details: this.inspec_details,
                        inspec_result: this.inspec_result,
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    // console.log(response.data.data)
                    this.FireHydrant_Table = response.data.data;
                    // console.log(response)
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    this.formatData(this.FireHydrant_Table);
                    // console.log("this.FireHydrant_Table == id  ",this.FireHydrant_Table)

                    // this.search()
                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            this.search();
            this.loading = false;
        },
        async searchAllFireHydrant() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            const organizeName = this.getOrganize_name();
            this.columns_img = false;
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'fast-search-all-table-firehydrant',
                        pipe_size: this.pipe_size,
                        ifh_firehydrant_code: this.ifh_firehydrant_code,
                        soi_name: this.soi_name,
                        road_name: this.road_name,
                        community_name: this.community_name !== null ? this.community_name.community_name : '',
                        province: this.selectedProvince,
                        userData: this.getUser(),
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        level: this.riskLevelSelected,
                        fire_station:
                            this.FireStationSelected == null
                                ? ''
                                : this.FireStationSelected.fs_tname == this.$i18n.t('selectAll')
                                ? ''
                                : this.FireStationSelected.fs_tname,
                        location: this.ifh_location,
                        status: this.status == null ? '' : this.status == this.$i18n.t('selectAll') ? '' : this.status,
                        inspec_details: this.inspec_details,
                        inspec_result: this.inspec_result,
                        userOrg,
                        organizeName
                    }
                })

                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    // console.log(response.data.data)
                    this.FireHydrant_Table = response.data.data;
                    // console.log(response)
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    this.formatData(this.FireHydrant_Table);
                    // console.log("this.FireHydrant_Table == id  ",this.FireHydrant_Table)

                    // this.search()
                    this.setSearchText_Footer();
                });

            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            this.loading = false;
        },

        getOrganize_name() {
            const token = localStorage.getItem('token');
            if (token) {
                const userData = this.decodeJWT(token);
                return userData ? userData.organize_name : null;
            }
            return null;
        },

        async fastSearchFireHydrant() {
            // console.log(this.decodeJWT(localStorage.getItem('token')).permission_id);
            this.isSearchMode = false;

            if (!this.checkToken()) {
                return;
            }

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            const organizeName = this.getOrganize_name();

            this.columns_img = false;
            this.ms = true;
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'fast-search-table-firehydrant',
                        pipe_size: this.pipe_size,
                        ifh_firehydrant_code: this.ifh_firehydrant_code,
                        soi_name: this.soi_name,
                        road_name: this.road_name,
                        community_name: this.community_name !== null ? this.community_name.community_name : '',
                        province: this.selectedProvince,
                        userData: this.getUser(),
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        level: this.riskLevelSelected,
                        fire_station:
                            this.FireStationSelected == null
                                ? ''
                                : this.FireStationSelected.fs_tname == this.$i18n.t('selectAll')
                                ? ''
                                : this.FireStationSelected.fs_tname,
                        location: this.ifh_location,
                        status: this.status == null ? '' : this.status == this.$i18n.t('selectAll') ? '' : this.status,
                        inspec_details: this.inspec_details,
                        inspec_result: this.inspec_result,
                        userOrg,
                        organizeName,
                        pagination: {
                            page: this.lazyParams.page || 1,
                            limit: this.lazyParams.rows || 10
                        }
                    }
                })
                .then((response) => {
                    this.FireHydrant_Table = response.data.data;
                    this.cloneTable = response.data.data;
                    this.lazyParams.totalRecords = Number(response.data.total); // Ensure totalRecords is a number
                    this.formatData(this.FireHydrant_Table);
                    this.setSearchText_Footer();
                });

            if (this.columns_disabled == true) {
                this.FireHydrant_Table = this.cloneTable;
            } else {
                this.FireHydrant_Table = [];
            }

            this.loading = false;
        },

        async onPage(event) {
            const newPage = Math.floor(event.first / event.rows) + 1;

            this.lazyParams = {
                first: event.first,
                rows: event.rows,
                page: newPage,
                totalRecords: this.lazyParams.totalRecords
            };

            // Only fetch new data if page actually changed
            if (newPage !== this.currentPage) {
                this.currentPage = newPage;
                await this.fastSearchFireHydrant();
                if (this.isSelectAll) {
                    this.selectedFireHydrant = [...this.FireHydrant_Table];
                } else {
                    this.selectedFireHydrant = [];
                }
            }
        },

        updateIndexes() {
            this.FireHydrant_Table.forEach((item, index) => {
                item.index = index + 1;
            });
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.pipe_size !== '' ||
                this.soi_name !== '' ||
                this.road_name !== '' ||
                this.community_name !== '' ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null ||
                this.FireStationSelected !== null ||
                this.status !== null ||
                this.inspec_details !== '' ||
                this.inspec_result !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ขนาด' && this.pipe_size !== '') {
                        element.textShow = `${this.pipe_size} mm.`;
                    }
                    if (element.DataName === 'ซอย/ตรอก' && this.soi_name !== '') {
                        element.textShow = this.soi_name;
                    }
                    if (element.DataName === 'ถนน' && this.road_name !== '') {
                        element.textShow = this.road_name;
                    }
                    if (element.DataName === 'ชุมชน' && this.community_name !== '') {
                        element.textShow = this.community_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                    if (element.DataName === 'สถานีดับเพลิงและกู้ภัย' && this.FireStationSelected !== null) {
                        element.textShow = this.FireStationSelected.fs_tname;
                    }
                    if (element.DataName === 'สถานะ' && this.status !== null) {
                        element.textShow = this.status;
                    }
                    if (element.DataName === 'รายละเอียดการตรวจสอบ' && this.inspec_details !== '') {
                        element.textShow = this.inspec_details;
                    }
                    if (element.DataName === 'ผลการดำเนินการ' && this.inspec_result !== '') {
                        element.textShow = this.inspec_result;
                    }
                }
                this.text_Footer = true;
            }
        },
        selectMap_passValue(variable) {
            this.ifh_lat = variable.lat.toFixed(6);
            this.ifh_lon = variable.lng.toFixed(6);
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด

            if (this.ifh_lat !== null && this.ifh_lon !== null && this.ifh_lat !== '' && this.ifh_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async inputMap_latlon() {
            if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                try {
                    this.locationLoading = true; // Show loading indicator

                    const response = await this.axios.get(
                        `https://api.deemap.com/service/geocode/lat=${this.ifh_lat}/lon=${this.ifh_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
                    );

                    if (response.data.data.length > 0) {
                        const data = {
                            ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                            provinceName: response.data.data[0].PROV_TNAME,
                            amphurName: response.data.data[0].AMP_TNAME,
                            tambonName: response.data.data[0].TAM_TNAME,
                            postCODE: response.data.data[0].POSTCOD
                        };

                        const element = data.ADMIN_CODE;
                        const country_ID = `${element[0]}${element[1]}`;
                        const land_ID = `${element[2]}${element[3]}`;
                        const province_ID = `${element[4]}${element[5]}`;
                        const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                        const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                        if (country_ID == '66' && land_ID !== '00') {
                            // Reset all selections first to avoid watchers interfering with each other
                            this.ifh_selectedProvince = null;
                            this.ira_selectedAmphur = null;
                            this.ira_selectedTambon = null;

                            await this.$nextTick();

                            // Step 1: Directly load all options we need
                            // Load province options (should already be loaded, but let's make sure)
                            const provinceResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: { topic: 'get-province' }
                            });
                            this.provinceOptions = provinceResponse.data.data;

                            // Load amphur options for this province
                            const amphurResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: {
                                    topic: 'get-amphur',
                                    province_id: province_ID
                                }
                            });
                            this.amphurOptions = amphurResponse.data.data;
                            this.ira_isDisabledAmphur = 0;

                            // Load tambon options for this amphur
                            const tambonResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                                body: {
                                    topic: 'get-tambon',
                                    amphur_id: amphur_ID
                                }
                            });
                            this.tambonOptions = tambonResponse.data.data;
                            this.ira_isDisabledTambon = 0;

                            // Step 2: Now set all values in correct order
                            this.ifh_selectedProvince = {
                                province_name: data.provinceName,
                                province_id: province_ID
                            };

                            await this.$nextTick(); // Allow UI to update

                            this.ira_selectedAmphur = {
                                amphur_name: data.amphurName,
                                amphur_id: amphur_ID
                            };

                            await this.$nextTick(); // Allow UI to update

                            this.ira_selectedTambon = {
                                tambon_name: data.tambonName,
                                tambon_id: tambon_ID
                            };

                            // Reset all error flags
                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            // Step 3: Update community options based on the selected amphur
                            if (this.ira_selectedAmphur) {
                                await this.updateCommunityOptions(data.amphurName);
                            }

                            // Step 4: Update fire station options
                            await this.check_Fire_Form_search(
                                this.ira_selectedTambon,
                                this.ira_selectedAmphur,
                                this.ifh_selectedProvince,
                                'form',
                                true
                            );
                        } else {
                            this.handleLocationErrors(country_ID, data);
                        }
                    } else {
                        this.resetLocationSelections();
                    }
                } catch (error) {
                    console.error('Error in reverse geocoding:', error);
                    this.resetLocationSelections();
                } finally {
                    this.locationLoading = false; // Hide loading indicator
                }
            } else {
                this.resetLocationSelections();
            }
        },

        async loadAmphurOptions(provinceId) {
            if (!provinceId) return;

            try {
                // Enable the dropdown first
                this.ira_isDisabledAmphur = 0;

                const response = await this.axios.post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-amphur',
                        province_id: provinceId
                    }
                });

                this.amphurOptions = response.data.data;
                // console.log('Loaded', this.amphurOptions.length, 'amphur options');
            } catch (error) {
                console.error('Failed to load amphur options:', error);
                this.ira_isDisabledAmphur = 1;
            }
        },

        // Helper method to load tambon options
        async loadTambonOptions(amphurId) {
            if (!amphurId) return;

            try {
                // Enable the dropdown first
                this.ira_isDisabledTambon = 0;

                const response = await this.axios.post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-tambon',
                        amphur_id: amphurId
                    }
                });

                this.tambonOptions = response.data.data;
                // console.log('Loaded', this.tambonOptions.length, 'tambon options');
            } catch (error) {
                console.error('Failed to load tambon options:', error);
                this.ira_isDisabledTambon = 1;
            }
        },

        // Helper method to reset all location selections
        resetLocationSelections() {
            this.ifh_selectedProvince = null;
            this.ira_selectedAmphur = null;
            this.ira_selectedTambon = null;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;
        },

        handleInputLatLon() {
            this.error_ifh_lat = false; // Clear the error flag when typing
            this.error_ifh_lat_dot = false; // Clear the error flag for multiple dots
            this.error_ifh_lon = false;
            this.error_ifh_lon_dot = false;
        },
        handleInput() {
            this.inputMap_latlon(); // Call your existing inputMap_latlon function
            this.handleInputLatLon(); // Call the handleInputLatLon function
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.ifh_selectedProvince",this.ifh_selectedProvince)
            //   console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
            //   console.log("this.ira_selectedTambon",this.ira_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';

            if (this.ifh_selectedProvince) {
                this.sP.push(this.ifh_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.ira_selectedAmphur) {
                this.sA.push(this.ira_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.ifh_selectedProvince == null) {
                this.ifh_lat = '';
                this.ifh_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.ira_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.ifh_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ifh_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.ira_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.ira_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ifh_lat = lat.toFixed(6);
                        this.ifh_lon = lon.toFixed(6);

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.ira_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.ira_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ira_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.ira_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ifh_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.ifh_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ifh_lat = lat.toFixed(6);
                            this.ifh_lon = lon.toFixed(6);

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.ifh_lat = '';
                    this.ifh_lon = '';
                }
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();

            this.displayConfirmation = false;
            await this.postFirehydrantMutation(`${this.$url_service}/initial/firehydrant?user=${userId}`, {
                    body: {
                        topic: 'delete-firehydrant',
                        id: this.temp
                    }
                })
                .then(() =>
                    // this.initialData()
                    // this.searchFireHydrant()
                    this.fastSearchFireHydrant()
                );
            this.$fire({
                type: 'success',
                title: 'ลบข้อมูลสำเร็จ',
                text: 'ข้อมูลหัวจ่ายน้ำดับเพลิง',
                timer: 3000,
                confirmButtonColor: '#28B463'
            });
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            //Check null value

            //   if (this.ifh_pipe_size == "") {
            //     this.error_ifh_pipe_size = true;
            // }else if (this.ifh_lat == "") {
            //     this.error_ifh_lat = true;
            // }else if (this.ifh_lon == "") {
            //     this.error_ifh_lon = true;
            // } else {

            //ตัวแดงทั้งหมด
            if (
                this.ifh_pipe_size == '' ||
                this.ifh_selectedProvince == null ||
                this.ifh_selectedProvince == 'null' ||
                this.ira_selectedAmphur == null ||
                this.ira_selectedAmphur == 'null' ||
                this.ira_selectedTambon == null ||
                this.ira_selectedTambon == 'null' ||
                this.ifh_lat == '' ||
                !/^13\.\d+$/.test(this.ifh_lat) ||
                this.ifh_lon == '' ||
                !/^100\.\d+$/.test(this.ifh_lon) ||
                this.ifs_status == null ||
                this.ifs_status == 'null' ||
                this.ifh_FireStationSelected == null ||
                this.ifh_FireStationSelected == 'null'
            ) {
                if (this.ifh_pipe_size == '') {
                    this.error_ifh_pipe_size = true;
                }
                if (this.ifh_selectedProvince == null) {
                    this.error_ifh_selectedProvince = true;
                }
                if (this.ifh_selectedProvince == 'null') {
                    this.error_ifh_selectedProvince = true;
                }
                if (this.ira_selectedAmphur == null) {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedAmphur == 'null') {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedTambon == null) {
                    this.error_ira_selectedTambon = true;
                }
                if (this.ira_selectedTambon == 'null') {
                    this.error_ira_selectedTambon = true;
                }
                if (this.ifh_lat == '') {
                    this.error_ifh_lat_dot = false;
                    this.error_ifh_lat = true;
                } else if (!/^13\.\d+$/.test(this.ifh_lat)) {
                    this.error_ifh_lat = false;
                    this.error_ifh_lat_dot = true;
                }
                if (this.ifh_lon == '') {
                    this.error_ifh_lon_dot = false;
                    this.error_ifh_lon = true;
                } else if (!/^100\.\d+$/.test(this.ifh_lon)) {
                    this.error_ifh_lon = false;
                    this.error_ifh_lon_dot = true;
                }
                if (this.ifs_status == null) {
                    this.error_ifh_status = true;
                }
                if (this.ifs_status == 'null') {
                    this.error_ifh_status = true;
                }
                if (this.ifh_FireStationSelected == null) {
                    this.error_ifh_FireStationSelected = true;
                }
                if (this.ifh_FireStationSelected == 'null') {
                    this.error_ifh_FireStationSelected = true;
                }
            } else {
                if (this.selectedData == '') {
                    const lat = this.ifh_lat.trim();
                    const lon = this.ifh_lon.trim();

                    const formattedLat = Number(lat).toFixed(6).padEnd(9, '0');
                    const formattedLon = Number(lon).toFixed(6).padEnd(9, '0');
                    // console.log('this.selectedData =', this.selectedData);
                    // console.log('add-firehydran');
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ
                    // console.log(this.$refs.io_image.innerText)
                    // console.log(this.$refs.io_image.innerText)
                    // console.log(this.imageName)
                    // console.log(formattedLat, formattedLon)
                    // console.log(this.ifh_selectedProvince, this.ira_selectedAmphur, this.ira_selectedTambon)

                    const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();
                    // console.log('userId', userId);
                    await this.axios
                        .post(`${this.$url_service}/initial/firehydrant?user=${userId}`, {
                            body: {
                                topic: 'add-firehydrant',
                                userOrg,
                                userData: this.getUser(),
                                pipe_size: this.ifh_pipe_size,
                                soi_name: this.ifh_soi_name,
                                road_name: this.ifh_road_name,
                                community_name: this.ifh_community_name !== null ? this.ifh_community_name.community_name : '',
                                location_id: this.ira_selectedTambon,
                                province: this.ifh_selectedProvince.province_name,
                                amphur: this.ira_selectedAmphur.amphur_name,
                                tambon: this.ira_selectedTambon.tambon_name,
                                lat: formattedLat,
                                lon: formattedLon,
                                fire_station: this.ifh_FireStationSelected,
                                status: this.ifs_status,
                                inspec_details: this.ifs_inspec_details,
                                inspec_result: this.ifs_inspec_result,
                                image: this.$refs.io_image.innerText === '' ? '-' : this.$refs.io_image.innerText,
                                // imageName: this.imageName === "" ? "" : this.imageName,
                                location: this.ifh_location === '' ? '' : this.ifh_location,
                                code: this.firehydrant_code,
                                create_by_fullname: userId,
                                edit_by_fullname: userId
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // (this.initialData());
                                // this.searchFireHydrant()
                                this.fastSearchFireHydrant();
                        });
                    // โหลดเพิ่มแก้ไข 5/8
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 5/8 จบ
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.FireHydrantModal = false;
                    this.$fire({
                        type: 'success',
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        text: 'ข้อมูลหัวจ่ายน้ำดับเพลิง',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                } else {
                    // console.log('this.selectedData =', this.selectedData);
                    if (this.$refs.io_image.innerText == '') {
                        this.$refs.io_image.innerText = this.url;
                    } else {
                        this.$refs.io_image.innerText = this.$refs.io_image.innerText;
                    }

                    if (this.ifh_FireStationSelected.fs_tname == null || this.ifh_FireStationSelected.fs_tname == 'null') {
                        this.error_ifh_FireStationSelected = true;
                    } else {
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        const lat = this.ifh_lat.trim();
                        const lon = this.ifh_lon.trim();
                        // console.log(this.$refs.io_image.innerText === "")
                        const formattedLat = Number(lat).toFixed(6).padEnd(9, '0');
                        const formattedLon = Number(lon).toFixed(6).padEnd(10, '0');
                        // console.log(this.$refs.io_image.innerText)
                        const FireStation = this.FireStationOptions_Form.find((x) => x.fs_tname == this.ifh_FireStationSelected.fs_tname);
                        if (FireStation) {
                            this.ifh_FireStationSelected = FireStation;
                        }
                        // const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();
                        console.log('userId', userId);
                        await this.postFirehydrantMutation(`${this.$url_service}/initial/firehydrant?user=${userId}`, {
                                body: {
                                    topic: 'edit-firehydrant',
                                    id: this.temp,
                                    pipe_size: this.ifh_pipe_size,
                                    soi_name: this.ifh_soi_name,
                                    road_name: this.ifh_road_name,
                                    userData: this.getUser(),
                                    community_name: this.ifh_community_name !== null ? this.ifh_community_name.community_name : '',
                                    location_id: this.ira_selectedTambon,
                                    province: this.ifh_selectedProvince,
                                    amphur: this.ira_selectedAmphur,
                                    tambon: this.ira_selectedTambon,
                                    lat: formattedLat,
                                    lon: formattedLon,
                                    fire_station: this.ifh_FireStationSelected,
                                    status: this.ifs_status,
                                    inspec_details: this.ifs_inspec_details,
                                    inspec_result: this.ifs_inspec_result,
                                    image: this.$refs.io_image.innerText === '' ? '-' : this.$refs.io_image.innerText,
                                    location: this.ifh_location === '' ? '' : this.ifh_location,
                                    code: this.firehydrant_code,
                                    edit_by_fullname: userId
                                }
                            })
                            .then(() =>
                                // this.initialData()
                                // this.searchFireHydrant()
                                this.fastSearchFireHydrant()
                            );
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        this.$fire({
                            type: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ',
                            text: 'ข้อมูลหัวจ่ายน้ำดับเพลิง',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        // console.log("Edit data", this.ifh_location);
                        this.FireHydrantModal = false;
                    }
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log('data =', data);
            this.header = this.$i18n.t('ifh_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'showone-firehydrant',
                        userData: this.getUser(),
                        id: data
                    }
                })
                .then((response) => {
                    // console.log('response.data.data', response.data.data),
                    (this.selectedData = response.data.data),
                        // (console.log("this.selectedData",this.selectedData)),
                        (this.ifh_pipe_size = response.data.data.pipe_size),
                        (this.ifh_soi_name = response.data.data.soi_name),
                        (this.ifh_road_name = response.data.data.road_name),
                        // console.log('Set ira_selectedAmphur to:', this.ira_selectedAmphur);
                        // console.log('Set ifh_community_name to:', this.ifh_community_name);

                        (this.ifh_lat = response.data.data.event_lat),
                        (this.ifh_lon = response.data.data.event_lon);
                    (this.ifh_selectedProvince = {
                        province_id: response.data.data.province_id || '',
                        province_name: response.data.data.province_name
                    }),
                        (this.ira_selectedAmphur = {
                            amphur_id: response.data.data.amphur_id || '',
                            amphur_name: response.data.data.amphur_name
                        }),
                        (this.ira_selectedTambon = {
                            tambon_id: response.data.data.tambon_id || '',
                            tambon_name: response.data.data.tambon_name
                        }),
                        (this.ifh_community_name = {
                            community_id: response.data.data.community_id || '',
                            community_name: response.data.data.community_name
                        }),
                        (this.ifh_FireStationSelected = {
                            fs_id: response.data.data.fire_station || '',
                            fs_tname: response.data.data.fire_station
                        });
                    this.ifh_location = response.data.data.location;
                    this.ifs_status = response.data.data.status;
                    this.ifs_inspec_details = response.data.data.inspec_details;
                    this.ifs_inspec_result = response.data.data.inspec_result;

                    this.url = this.pickRecordImageRaw(response.data.data, 'image', 'image_cloud');

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    this.firehydrant_code = response.data.data.code == null ? '' : response.data.data.code;
                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.ifh_lat !== '' && this.ifh_lat !== null && this.ifh_lon !== '' && this.ifh_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ

                    this.FireHydrantModal = true;
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('ifh_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.selectedData = '';
                this.FireHydrantModal = false;
                this.i = 0;
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.ifh_pipe_size = '';
            this.ifh_soi_name = '';
            this.ifh_road_name = '';
            this.ifh_community_name = null;
            this.ifh_lat = '';
            this.ifh_lon = '';
            this.error_ifh_pipe_size = false;
            this.error_ifh_selectedProvince = false;
            this.error_ira_selectedAmphur = false;
            this.error_ira_selectedTambon = false;
            this.error_ifh_status = false;
            this.error_ifh_lat = false;
            this.error_ifh_lat_dot = false;
            this.error_ifh_lon = false;
            this.error_ifh_lon_dot = false;
            this.ifh_selectedProvince = null;
            this.ifh_FireStationSelected = null;
            this.error_ifh_FireStationSelected = false;
            this.ifs_status = null;
            this.ifs_inspec_details = '';
            this.ifs_inspec_result = '';
            this.firehydrant_code = '';

            this.ifh_location = '';

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.url = null;
            document.getElementById('fireHydrant_uploadImageFile').value = '';

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.selectedProvince = null;
            this.pipe_size = '';
            this.soi_name = '';
            this.road_name = '';
            this.community_name = '';
            this.FireStationSelected = null;
            this.status = null;
            this.inspec_details = '';
            this.inspec_result = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.FireHydrant_Table = [];
        },
        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.selectedProvince = null;
                this.pipe_size = '';
                this.soi_name = '';
                this.road_name = '';
                this.community_name = '';
                this.FireStationSelected = null;
                this.status = null;
                this.inspec_details = '';
                this.inspec_result = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
                this.FireHydrant_Table = [];
            }
        },
        // Doe โหลด โทรศัพท์
        // Doe :   เพิ่ม มุดmap 4/4
        sendM(ifh_lat, ifh_lon) {
            let lat = ifh_lat;
            let lon = ifh_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province, FireStationSelected) {
            if (FireStationSelected) {
                this.FSS = FireStationSelected;
            } else {
                this.FSS = {};
            }

            if (tambon) {
                this.PAT = tambon;
            } else if (amphur) {
                this.PAT = amphur;
            } else if (province) {
                this.PAT = province;
            } else {
                this.PAT = {};
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  -->
        async receiveM_PAT(data) {
            try {
                const element = data.ADMIN_CODE;
                const country_ID = `${element[0]}${element[1]}`;
                const land_ID = `${element[2]}${element[3]}`;
                const province_ID = `${element[4]}${element[5]}`;
                const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                if (country_ID == '66' && land_ID !== '00') {
                    this.locationLoading = true; // Show loading indicator

                    // Reset all selections first
                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;

                    await this.$nextTick();

                    // Load all required options first
                    // Load amphur options for this province
                    const amphurResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: province_ID
                        }
                    });
                    this.amphurOptions = amphurResponse.data.data;
                    this.ira_isDisabledAmphur = 0;

                    // Load tambon options for this amphur
                    const tambonResponse = await this.axios.post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: amphur_ID
                        }
                    });
                    this.tambonOptions = tambonResponse.data.data;
                    this.ira_isDisabledTambon = 0;

                    // Now set all values in correct order
                    this.ifh_selectedProvince = {
                        province_name: data.provinceName,
                        province_id: province_ID
                    };

                    await this.$nextTick(); // Allow UI to update

                    this.ira_selectedAmphur = {
                        amphur_name: data.amphurName,
                        amphur_id: amphur_ID
                    };

                    await this.$nextTick(); // Allow UI to update

                    this.ira_selectedTambon = {
                        tambon_name: data.tambonName,
                        tambon_id: tambon_ID
                    };

                    // Reset all error flags
                    this.error_latlon_country = false;
                    this.error_latlon_land = false;
                    this.error_latlon_P = false;
                    this.error_latlon_A = false;
                    this.error_latlon_T = false;

                    // Update community options based on the selected amphur
                    if (this.ira_selectedAmphur) {
                        await this.updateCommunityOptions(data.amphurName);
                    }

                    // Update fire station options
                    await this.check_Fire_Form_search(this.ira_selectedTambon, this.ira_selectedAmphur, this.ifh_selectedProvince, 'form', true);
                } else {
                    if (country_ID !== '66') {
                        this.error_latlon_country = true;
                    } else {
                        this.error_latlon_country = false;
                    }

                    if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                        this.error_latlon_P = true;
                    } else {
                        this.error_latlon_P = false;
                    }
                    if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                        this.error_latlon_A = true;
                    } else {
                        this.error_latlon_A = false;
                    }
                    if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                        this.error_latlon_T = true;
                    } else {
                        this.error_latlon_T = false;
                    }

                    this.ifh_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                }
            } catch (error) {
                console.error('Error in receiveM_PAT:', error);
                this.resetLocationSelections();
            } finally {
                this.locationLoading = false; // Hide loading indicator
            }
        },

        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->

        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    pipe_size: { cellWidth: 93 },
                    fire_station: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    pipe_size: { cellWidth: 80 }
                };
            } else if (this.columnsSelectorDialog.length <= 15) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7;
                this.PDF_FontBodyVer = 5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21 },
                    pipe_size: { cellWidth: 35 },
                    fire_station: { cellWidth: 53 },
                    // inspec_details:{cellWidth:40},
                    status: { cellWidth: 28 },
                    event_latPDF: { cellWidth: 28 },
                    event_lonPDF: { cellWidth: 28 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            } else {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7;
                this.PDF_FontBodyVer = 5;
                this.PDF_BodySizeSelect = this.PDF_BodySize;
                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_pipe_size = false;
                this.columns_img = false;
                this.columns_soi_name = false;
                this.columns_road_name = false;
                this.columns_community_name = false;
                this.columns_fire_station = false;
                this.columns_location = false;
                this.columns_tambon_name = false;
                this.columns_amphur_name = false;
                this.columns_province_name = false;
                this.columns_event_lat = false;
                this.columns_event_lon = false;
                this.columns_fire_hydrant_details = false;
                this.columns_status = false;
                this.columns_inspec_details = false;
                this.columns_inspec_result = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;

                this.GetData_ColumnsSearch = [];
                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // let getData = this.GetData_ColumnsSearch;
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'pipe_size') {
                        this.columns_pipe_size = true;
                    } else if (!getData.includes('pipe_size')) {
                        this.columns_pipe_size = false;
                    }

                    if (element == 'image') {
                        this.columns_img = true;
                    } else if (!getData.includes('image')) {
                        this.columns_img = false;
                    }

                    if (element == 'soi_name') {
                        this.columns_soi_name = true;
                    } else if (!getData.includes('soi_name')) {
                        this.columns_soi_name = false;
                    }

                    if (element == 'road_name') {
                        this.columns_road_name = true;
                    } else if (!getData.includes('road_name')) {
                        this.columns_road_name = false;
                    }

                    if (element == 'community_name') {
                        this.columns_community_name = true;
                    } else if (!getData.includes('community_name')) {
                        this.columns_community_name = false;
                    }

                    if (element == 'fire_station') {
                        this.columns_fire_station = true;
                    } else if (!getData.includes('fire_station')) {
                        this.columns_fire_station = false;
                    }

                    if (element == 'location') {
                        this.columns_location = true;
                    } else if (!getData.includes('location')) {
                        this.columns_location = false;
                    }

                    if (element == 'tambon_name') {
                        this.columns_tambon_name = true;
                    } else if (!getData.includes('tambon_name')) {
                        this.columns_tambon_name = false;
                    }

                    if (element == 'amphur_name') {
                        this.columns_amphur_name = true;
                    } else if (!getData.includes('amphur_name')) {
                        this.columns_amphur_name = false;
                    }

                    if (element == 'province_name') {
                        this.columns_province_name = true;
                    } else if (!getData.includes('province_name')) {
                        this.columns_province_name = false;
                    }

                    if (element == 'event_latPDF') {
                        this.columns_event_lat = true;
                    } else if (!getData.includes('event_latPDF')) {
                        this.columns_event_lat = false;
                    }

                    if (element == 'event_lonPDF') {
                        this.columns_event_lon = true;
                    } else if (!getData.includes('event_lonPDF')) {
                        this.columns_event_lon = false;
                    }

                    if (element == 'status') {
                        this.columns_status = true;
                    } else if (!getData.includes('status')) {
                        this.columns_status = false;
                    }

                    if (element == 'inspec_details') {
                        this.columns_inspec_details = true;
                    } else if (!getData.includes('inspec_details')) {
                        this.columns_inspec_details = false;
                    }
                    if (element == 'inspec_result') {
                        this.columns_inspec_result = true;
                    } else if (!getData.includes('inspec_result')) {
                        this.columns_inspec_result = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        },
        // Doe PDF เลือกได้  5/5 จบ

        async genCodeId() {
            // console.log('this.ifh_pipe_size', this.ifh_pipe_size);
            // console.log('API Endpoint:', `${this.$url_service}/initial/firehydrant`);
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/firehydrant`, {
                    body: {
                        topic: 'generatecode-firehydrant',
                        code: this.ifh_pipe_size
                    }
                });
                // console.log('response.data', response.data);
                if (response.data.newCode) {
                    this.firehydrant_code = response.data.newCode; // Set the firehydrant_code
                }
            } catch (error) {
                console.error('API call error:', error);
            }
        },

        async genQrCode(code) {
            // Get fresh data
            // await this.fastSearchFireHydrant();

            // Find matching record
            const firehydrant = this.FireHydrant_Table.find((item) => item.code === code);
            // console.log('firehydrant', firehydrant);

            if (!firehydrant) {
                console.error('Firehydrant not found for code:', code);
                return;
            }

            // Extract the base URL up to the port number
            const baseUrl = window.location.origin;

            const firehydrant_id = firehydrant.firehydrant_id;
            const fullLink = `${baseUrl}/public/information/initial/fire-hydrant/details?firehydrantId=${firehydrant_id}`;
            this.code = code;
            // console.log('fullLink is :', fullLink);

            try {
                const qrDataURL = await QRCode.toDataURL(fullLink, { width: 300 });
                const qrImage = document.createElement('img');
                qrImage.src = qrDataURL;

                const printWindow = window.open('', '_blank');
                printWindow.document.open();
                printWindow.document.write(`<html><body>
                    <div id="qrCodeContainer" style="width: 5.98cm; height: 9cm; position: relative; border: 10px; border-style: double; text-align: center; box-shadow: inset 0px 0px 0px 5px #000; border-radius: 20px;">
                        <div style="  font-weight: 800; letter-spacing: 2px;
                text-shadow: 2px 2px 4px rgba(0,0,0,0.3); font-size: 30px; border-style: solid; border-width: 5px; border-color: #000; color: #000;"> สปภ. </div>
                        <img src="${qrDataURL}" alt="QR Code" style="width: 90%; "/>
                        <div class="code-label" style="margin-top: 10px; padding-top: 10px; padding-bottom:10px; font-size: 40px; border-style: solid; border-width: 5px; border-color: #000; color: #000;">${code}</div>
                    </div>
                </body></html>`);
                printWindow.document.close();

                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);
            } catch (error) {
                console.error('Failed to generate QR code:', error);
            }
        }
    },

    async mounted() {
        await this.loadFirehydrantPermissions();
        this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;

        this.initialCommunityData();
        if (this.$route.query.code) {
            this.paramsQuery = this.$route.query.code;
            await this.fastSearchFireHydrant();
            this.paramsQuery = '';
            this.$router.replace({ query: { ...this.$route.query, code: undefined } });
            // console.log(window.location.href);
            // console.log(this.$route.path)
        }
    }
};
</script>

<style scoped>
@media print {
    body * {
        visibility: hidden;
        /* Hide everything on the page when printing, except the QR code container */
    }

    #qrCodeContainer,
    #qrCodeContainer * {
        visibility: visible;
    }

    #qrCodeContainer {
        position: absolute;
        left: 0;
        top: 0;
        width: 6.98cm;
        height: 8.23cm;
        display: block !important;
        /* Override any 'display: none' */
    }
}

.qr-container {
    position: relative;
    width: fit-content;
    padding: 20px;
    background: #fff;
    /* border: 17px; */
    /* border-style: double; */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    text-align: center;
    margin-top: 50px;
    box-shadow: inset 0px 0px 0px 17px #000;
    border-radius: 10px;
}
.qr-code {
    width: 300px;
    height: 300px;
    border-style: solid;
    border-width: 10px;
    border-color: #000;
    border-radius: 10px;
}
.code-label {
    margin-top: -20px;
    padding-top: 10px;
    font-size: 40px;
    /* font-weight: bold; */
    border-style: solid;
    border-width: 10px;
    border-color: #000;
    border-radius: 10px;
    color: #000;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgDia {
    width: 100%;
    display: block;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}

/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 991px) {
    #text_Footer {
        font-size: 1rem;
    }
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}

.hover-effect {
    text-decoration: none; /* Remove default underline */
    color: inherit; /* Inherit the color */
    transition: all 0.3s ease; /* Smooth transition */
}

.hover-effect:hover {
    text-decoration: underline; /* Underline text on hover */
    background-color: #f0f0f0; /* Change background color on hover */
    color: #000; /* Optional: Change text color on hover */
}
</style>
